export enum BankTransactionStatus {
    Rejected = 0,
    Approved,
    Pending
}
